// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toast_TKvqv {
	position: fixed;
	bottom: -100px;
	left: 50%;
	transform: translateX(-50%);
	background-color: var(--_3c3a3a-color);
	color: var(--white-color);
	padding: 13px 25px;
	border-radius: 5px 5px 0px 0px;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
	transition:
		transform 0.5s ease,
		opacity 0.5s ease;
	opacity: 0;
	z-index: 100000;
}

.toast_TKvqv.show_dbrPu {
	transform: translateX(-50%) translateY(0); 
	bottom: 0px;
	opacity: 1;
}

.toast_TKvqv.hide_uQbXS {
	transform: translateX(-50%) translateY(100px);
	bottom: -100px;
	opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/CalendarView/Calendar/components/CustomToast.module.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,cAAc;CACd,SAAS;CACT,2BAA2B;CAC3B,sCAAsC;CACtC,yBAAyB;CACzB,kBAAkB;CAClB,8BAA8B;CAC9B,wCAAwC;CACxC;;mBAEkB;CAClB,UAAU;CACV,eAAe;AAChB;;AAEA;CACC,yCAAyC;CACzC,WAAW;CACX,UAAU;AACX;;AAEA;CACC,6CAA6C;CAC7C,cAAc;CACd,UAAU;AACX","sourcesContent":[".toast {\n\tposition: fixed;\n\tbottom: -100px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\tbackground-color: var(--_3c3a3a-color);\n\tcolor: var(--white-color);\n\tpadding: 13px 25px;\n\tborder-radius: 5px 5px 0px 0px;\n\tbox-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n\ttransition:\n\t\ttransform 0.5s ease,\n\t\topacity 0.5s ease;\n\topacity: 0;\n\tz-index: 100000;\n}\n\n.toast.show {\n\ttransform: translateX(-50%) translateY(0); \n\tbottom: 0px;\n\topacity: 1;\n}\n\n.toast.hide {\n\ttransform: translateX(-50%) translateY(100px);\n\tbottom: -100px;\n\topacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toast": `toast_TKvqv`,
	"show": `show_dbrPu`,
	"hide": `hide_uQbXS`
};
export default ___CSS_LOADER_EXPORT___;
